import { render, staticRenderFns } from "./PixPendentes.vue?vue&type=template&id=3f912c1d"
import script from "./PixPendentes.vue?vue&type=script&lang=ts"
export * from "./PixPendentes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports